import React from "react";
import { Button } from "@mui/material";
import { Call } from "../../../api/apiCall";

interface ProjectActionButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: "contained" | "outlined";
  color?: "primary" | "secondary" | "success" | "error";
  size?: "small" | "medium" | "large";
  sx?: object;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  contentType?: string;
  action?: string;
  value?: string;
  readOnly?: boolean;
}

async function handleButtonClickLog({ contentType, action, value }: { contentType?: string; action?: string; value?: string }) {
  const logItem = {
    projectCode: localStorage.getItem("projectCode") || "",
    projectPhase: Number(localStorage.getItem("phaseId")),
    userId: Number(localStorage.getItem("userId")),
    contentType: contentType || "",
    action: action || "",
    value: value || "",
    accessDate: new Date(),
  };

  try {
    const res = await Call("logs/new", "post", { LogItem: logItem });
    const data = await res.json();
    if (data.success) {
      console.log("Log salvato!");
    } else {
      console.error("Log non salvato:", data.message);
    }
  } catch (err) {
    console.error("Error:", err);
  }
}

const ProjectActionButton: React.FC<ProjectActionButtonProps> = ({ children, onClick, variant = "outlined", color = "primary", size = "medium", sx = {}, disabled = false, type = "button", contentType, action, value }) => {
  const handleClick = async () => {
    await handleButtonClickLog({ contentType, action, value });
    if (onClick) onClick();
  };

  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      onClick={handleClick}
      sx={{
        minWidth: size === "small" ? 0 : undefined, // Keep minWidth 0 for small (likely icon buttons)
        px: size === "small" ? 1.5 : (size === "large" ? 3 : 2.5), // Adjust padding based on size
        py: size === "small" ? 1 : (size === "large" ? 1.5 : 1.25), // Adjust padding based on size
        ...sx,
      }}
      disabled={disabled}
      type={type}
    >
      {children}
    </Button>
  );
};

export default ProjectActionButton;
